var PossObjectCodeService = function () {
  var possObjectCodes = []
  var possObjectCodesById = {}

  return {
    getPossObjectCodes: function () {
      return possObjectCodes
    },
    getPossObjectCodeById: function (possObjectCodeId) {
      return possObjectCodesById[possObjectCodeId]
    },
    setPossObectCodes: function (_possObjectCodes) {
      possObjectCodesById = {}
      possObjectCodes = _possObjectCodes
      possObjectCodes.forEach(function (possObjectCode) {
        // Hash by Id
        possObjectCodesById[possObjectCode.Id] = possObjectCode
      })

      // $rootScope.$broadcast('setPossObectCodes', possObjectCodes);
    },
    updatePossObectCode: function (_possObjectCode) {
      // var possObjectCode = possObjectCodesById[_possObjectCode.Id]
      // TO do. some update of a property
      // $rootScope.$broadcast('updatePossObectCode', possObjectCode);
    }
  }
}

export default new PossObjectCodeService()



// WEBPACK FOOTER //
// ./src/services/PossObjectCodeService.js